import { BoxProps, styled } from '@mui/material';

export const CenterDot = styled('div')`
  position: absolute;
  bottom: -10px;
  right: calc(50% - 10px);
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: #FFF;
  border: 4px solid #0494FE;
}` as React.ComponentType<BoxProps>;

export const PlaceCard = styled('div')<{ withArrow?: boolean }>`
  border-radius: 15px;
  border: 1px solid #e4e7ec;
  background-color: #fff;
  display: flex;
  width: 255px;
  flex-direction: column;
  overflow: hidden;
  pointer-events: auto !important;

  & * {
    pointer-events: auto !important;
  }
  & svg {
    stroke: currentColor;
  }
  ${({ withArrow }) =>
    withArrow
      ? `
      ::before {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid white;
    }`
      : ''}
` as React.ComponentType<{ withArrow?: boolean }>;

export const PlaceCardNameIcon = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  & svg {
    height: 14px;
    width: auto;
  }
` as React.ComponentType<BoxProps>;

export const Cluster = styled('div')`
  width: 35px;
  height: 35px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 40px;
    height: 40px;
  }
  background-color: #0494FE;
  border: 4px solid #FFF;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
` as React.ComponentType<BoxProps>;

export const PlaceCardDot = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 45px;
  width: 45px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 50px;
    width: 50px;
  }
  padding: 10px;
  border-radius: 100%;
  border: 4px solid #fff;
  background: #0494fe;
  pointer-events: auto !important;
  cursor: pointer;

  ::before {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
  }

  & svg {
    height: 16px;
    ${({ theme }) => theme.breakpoints.up('sm')} {
      height: 24px;
    }
  }
` as React.ComponentType<BoxProps>;

export const PlaceCardDotIcon = styled('div')`
  height: 16px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 24px;
  }
  & svg {
    stroke: #fff;
    width: auto;
  }
` as React.ComponentType<BoxProps>;

export const PlaceCardRoute = styled('div')<{ isActive: boolean }>`
  display: flex;
  width: 33%;
  height: 56px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border: 1.222px solid ${({ isActive }) => (isActive ? '#0494FE' : '#ECECEC')};
  background: ${({ isActive }) => (isActive ? 'rgba(4, 148, 254, 0.06)' : '#fff')};
  box-shadow: 0px 1.222px 2.444px 0px rgba(16, 24, 40, 0.05);
  color: ${({ isActive }) => (isActive ? '#0494FE' : '#0D0D0D')};
  overflow: hidden;
  cursor: pointer;

  & svg {
    height: 20px;
    stroke: none;
    fill: currentColor;
  }
` as React.ComponentType<{ isActive: boolean }>;

export const MinimapStyle = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
  border: 2px solid #fff;
  cursor: pointer;
` as React.ComponentType<BoxProps>;

export const MinimapBg = styled('div')`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
` as React.ComponentType<BoxProps>;
